/**
 * @fileoverview
 * Centralised service for all 2FA API calls.
 * All methods return the Axios response promise.
 * Components only import what they need and handle UI state themselves.
 */

// const WALLET = 'wallet';
import store from "@/store";
import { errorToast } from "@/shared/services/helper";
import { apiCall } from "@/shared/services/apiCall";

export default {
    set2FaUserData(is2FaEnabled){
        let user = store.getters.stateUser;
        if (!user) return response;

        user.is_twofa_enable = is2FaEnabled ? 1 : 0;
        store.dispatch('setUser', user);
    },
    /**
     * Get current MFA status for the logged-in user.
     */
    check2faStatus() {
        let user = store.getters.stateUser;
        if(!user) return { is2faEnabled : false };
        return { is2faEnabled : user?.is_twofa_enable ?? false };
    },

    async check2FaDisable () {
        try{
            const response = await apiCall('post','CHECK_2FA_DISABLE')
            if(response && response?.status === 200){
                return {
                    error : false
                }
            }else{
                return{
                    error : true
                }
            }
        }catch(error){
            errorToast(Array.isArray(error) ? error[0] : 'Failed to reset the attempts.');
        }
    },

    /**
     * Toggle MFA disabled.
     */
    toggleMfa(otp) {
        return apiCall('post', 'DISABLE_2FA',{ twofa_code : otp });
    },

    /**
     * Generate Google Authenticator QR code + secret key.
     * @param {Function} apiCall
     * @param {string} email
     */
    generateGoogleSecret(apiCall) {
        return apiCall('get', 'TWO_FA_GOOGLE_GENERATE_SECRET');
    },

    /**
     * Verify a Google Authenticator TOTP code.
     * @param {Function} apiCall
     * @param {string} otp
     */
    verifyGoogleOtp(apiCall, otp) {
        return apiCall('post', 'TWO_FA_ENABLE', { twofa_code: (otp) });
    },

    update2fa(apiCall, otp) {
        return apiCall('post', 'UPDATE_2FA_DEVICE', { twofa_code: (otp) });
    },

    /**
     * Verify using existing MFA (authenticator code) during edit flow.
     * @param {Function} apiCall
     * @param {string} otp
     */
    verifyExistingMfa(apiCall, otp) {
        return apiCall('post', 'TWO_FA_VERIFY_EXISTING_MFA', { twofa_code: (otp)});
    }
};
